import ons from "onsenui";
import * as React from "react";
import * as Ons from "react-onsenui";
import { CordovaPlugin, cordovaPluginAvailable } from "../cordova_plugins";
import { openExternalUrl } from "../external_link";
import { isLoading, Loading } from "../Loading";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { ScreenSkeleton } from "./ScreenSkeleton";

export interface ChallengeContestor {
  photoUrl: string | null;
  fullName: string;
  points: number;
}

interface MedFlytChallengeScreenProps {
  referralCode: string | Loading;
  points: number | Loading;
  announcementTime: Date;
  challengeContestors: ChallengeContestor[] | Loading;
  onBackClick: () => void;
}

export class MedFlytChallengeScreen extends React.Component<MedFlytChallengeScreenProps, {}> {
  render() {
    return (
      <ScreenSkeleton
        onBackClick={this.props.onBackClick}
        title={translate(STRINGS.MEDFLYT_CHALLENGE)}
        titleBarStyle={ScreenSkeleton.TitleBarStyle.TRANSPARENT}
      >
        <div className="MedFlytChallengeScreen__root">
          <div className="MedFlytChallengeScreen__subheader">
            <div className="MedFlytChallengeScreen__crown MedFlytChallengeScreen__crownLeft" />
            <div className="MedFlytChallengeScreen__subheader_text">
              {translate(STRINGS.INVITE_CAREGIVERS_TO_MEDFLYT_AND_WIN_AMAZING_PRIZES)}
            </div>
            <div className="MedFlytChallengeScreen__crown MedFlytChallengeScreen__crownRight" />
          </div>

          <div className="MedFlytChallengeScreen__inviteNote">
            {translate(STRINGS.EACH_INVITE)} = 50 {translate(STRINGS.POINTS)}
          </div>

          <div className="MedFlytChallengeScreen__prizesCont">
            <div className="MedFlytChallengeScreen__prize">
              <div className="MedFlytChallengeScreen__prizeCrown" />
              <div className="MedFlytChallengeScreen__prizeCircle">
                <div className="MedFlytChallengeScreen__prizeRank">#1</div>
                <div className="MedFlytChallengeScreen__prizeReward">100$</div>
                <div className="MedFlytChallengeScreen__prize_amex" />
              </div>
            </div>

            <div className="MedFlytChallengeScreen__prize">
              <div className="MedFlytChallengeScreen__prizeCircle">
                <div className="MedFlytChallengeScreen__prizeRank">#2</div>
                <div className="MedFlytChallengeScreen__prizeReward">50$</div>
                <div className="MedFlytChallengeScreen__prize_amazon" />
              </div>
            </div>

            <div className="MedFlytChallengeScreen__prize">
              <div className="MedFlytChallengeScreen__prizeCircle">
                <div className="MedFlytChallengeScreen__prizeRank">#3</div>
                <div className="MedFlytChallengeScreen__prizeReward">25$</div>
                <div className="MedFlytChallengeScreen__prize_starbucks" />
              </div>
            </div>
          </div>

          {(() => {
            const referralCode = this.props.referralCode;
            if (isLoading(referralCode)) {
              return <Ons.ProgressCircular indeterminate={true} />;
            } else {
              return (
                <div>
                  <div
                    className="MedFlytChallengeScreen__referral"
                    onClick={() => shareMedFlytChallengeInviteLink(referralCode)}
                  >
                    {translate(STRINGS.CLICK_HERE_TO_SHARE_YOUR_REFERRAL_CODE)}{" "}
                    <span className="MedFlytChallengeScreen__referral_code">
                      {this.props.referralCode}
                    </span>
                  </div>

                  <div
                    className="MedFlytChallengeScreen__inviteFriendsButton"
                    onClick={() => shareMedFlytChallengeInviteLink(referralCode)}
                  >
                    {translate(STRINGS.INVITE_FRIENDS)}
                  </div>
                </div>
              );
            }
          })()}

          <div className="MedFlytChallengeScreen__pointsHeart">
            <div className="MedFlytChallengeScreen__pointsHeart_num">
              {isLoading(this.props.points) ? (
                <Ons.ProgressCircular indeterminate={true} />
              ) : (
                this.props.points
              )}
            </div>
            <div className="MedFlytChallengeScreen__pointsHeart_points">
              {!isLoading(this.props.points) ? translate(STRINGS.POINTS) : null}
            </div>
          </div>

          <div className="MedFlytChallengeScreen__announcement">
            {translate(STRINGS.THE_NEXT_WINNERS_ANNOUNCEMENT)}
          </div>

          <div className="MedFlytChallengeScreen__announcementCountdown">
            <CountdownTimer deadline={this.props.announcementTime} />
          </div>

          <div className="MedFlytChallengeScreen__topCaregiversHeader">
            {translate(STRINGS.TOP_CAREGIVERS_IN_YOUR_AREA)}
          </div>

          {isLoading(this.props.challengeContestors) ? (
            <Ons.ProgressCircular indeterminate={true} />
          ) : (
            <table className="MedFlytChallengeScreen__topCaregiversTable">
              <tbody>
                {this.props.challengeContestors.map((contestor, index) => (
                  <tr key={index}>
                    <td>
                      {contestor.photoUrl === null ? (
                        <div className="MedFlytChallengeScreen__topCaregiversTable_photo MedFlytChallengeScreen__topCaregiversTable_photoDefault" />
                      ) : (
                        <img
                          className="MedFlytChallengeScreen__topCaregiversTable_photo"
                          src={contestor.photoUrl}
                        />
                      )}
                    </td>
                    <td>
                      <div className="MedFlytChallengeScreen__topCaregiversTable_fullName">
                        {contestor.fullName}
                      </div>
                    </td>
                    <td className="MedFlytChallengeScreen__topCaregiversTable_points">
                      {contestor.points}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          <div className="MedFlytChallengeScreen__shareHeader">
            {translate(STRINGS.SPREAD_THE_WORD)}
          </div>

          {(() => {
            const referralCode = this.props.referralCode;
            if (isLoading(referralCode)) {
              return <Ons.ProgressCircular indeterminate={true} />;
            } else {
              return (
                <div className="MedFlytChallengeScreen__shareButtonsCont">
                  <div
                    className="MedFlytChallengeScreen__shareButton MedFlytChallengeScreen__shareButton_facebook"
                    onClick={() => shareMedFlytChallengeFacebook(referralCode)}
                  />
                  <div
                    className="MedFlytChallengeScreen__shareButton MedFlytChallengeScreen__shareButton_instagram"
                    onClick={() => shareMedFlytChallengeInstagram(referralCode)}
                  />
                  <div
                    className="MedFlytChallengeScreen__shareButton MedFlytChallengeScreen__shareButton_whatsapp"
                    onClick={() => shareMedFlytChallengeWhatsApp(referralCode)}
                  />
                  <div
                    className="MedFlytChallengeScreen__shareButton MedFlytChallengeScreen__shareButton_twitter"
                    onClick={() => shareMedFlytChallengeTwitter(referralCode)}
                  />
                </div>
              );
            }
          })()}

          <div
            className="MedFlytChallengeScreen__termsLink"
            onClick={() =>
              openExternalUrl(
                "https://s3-us-west-2.amazonaws.com/medflytfiles/Sweepstakes+Rules+and+Terms.pdf"
              )
            }
          >
            {translate(STRINGS.FULL_TERMS_AND_CONDITIONS_MEDFLYT_CHALLENGE)}
          </div>

          {ons.platform.isIOS() ? (
            <div className="MedFlytChallengeScreen__appleDisclaimer">
              {translate(STRINGS.APPLE_IS_NOT_INVOLVED_IN_ANY_WAY_WITH_THE_CONTEST_OR_SWEEPSTAKES)}
            </div>
          ) : null}
        </div>
      </ScreenSkeleton>
    );
  }
}

interface CountdownTimerProps {
  deadline: Date;
}

class CountdownTimer extends React.Component<CountdownTimerProps> {
  constructor(props: CountdownTimerProps) {
    super(props);
    this.timerHandle = setInterval(() => {
      this.forceUpdate();
    }, 1000) as any;
  }

  timerHandle: number;

  componentWillUnmount() {
    clearInterval(this.timerHandle);
  }

  render() {
    const now = new Date();

    let secondsLeft = Math.floor((this.props.deadline.getTime() - now.getTime()) / 1000);

    if (secondsLeft < 0) {
      secondsLeft = 0;
    }

    const timeLeft = splitTime(secondsLeft);

    return (
      <div>
        {timeLeft.days > 0 ? "" + timeLeft.days + "d" : ""}{" "}
        {timeLeft.days > 0 || timeLeft.hours > 0 ? "" + timeLeft.hours + "h" : ""}{" "}
        {timeLeft.days > 0 || timeLeft.hours > 0 || timeLeft.minutes > 0
          ? "" + timeLeft.minutes + "m"
          : ""}{" "}
        {timeLeft.seconds}s
      </div>
    );
  }
}

interface TimeComponents {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function splitTime(seconds: number): TimeComponents {
  const SECONDS_IN_DAY = 24 * 60 * 60;
  const SECONDS_IN_HOUR = 60 * 60;
  const SECONDS_IN_MINUTE = 60;

  let secondsLeft = seconds;

  const days = Math.floor(secondsLeft / SECONDS_IN_DAY);
  secondsLeft -= days * SECONDS_IN_DAY;

  const hours = Math.floor(secondsLeft / SECONDS_IN_HOUR);
  secondsLeft -= hours * SECONDS_IN_HOUR;

  const minutes = Math.floor(secondsLeft / SECONDS_IN_MINUTE);
  secondsLeft -= minutes * SECONDS_IN_MINUTE;

  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: secondsLeft,
  };
}

function referralInviteLink(referralCode: string): string {
  return "i.medflyt.com/invite/" + referralCode;
}

function referralMessage(referralCode: string): string {
  return (
    "Hi, I'm happy to invite you to use Medflyt 👑👑👑 \n" +
    "An amazing app that helps you find new cases and get all the information right away. \n" +
    "\n" +
    "Click on this link to join: " +
    referralInviteLink(referralCode) +
    " \n" +
    "Don't forget to put the referring code after you complete the registration: " +
    referralCode
  );
}

export async function shareMedFlytChallengeInviteLink(referralCode: string): Promise<void> {
  if (!(await cordovaPluginAvailable(CordovaPlugin.SocialSharing))) {
    return;
  }

  (window as any).plugins.socialsharing.shareWithOptions({
    message: referralMessage(referralCode),
    subject: "Medflyt Caregiver challenge",
    files: [""],
    url: "",
    chooserTitle: "Pick an app",
  });
}

function socialShareError(title: string): () => void {
  return () => {
    ons.notification.alert({
      animation: "none",
      modifier: "material",
      title: "Error Sharing",
      message: "" + title + " Not Available",
      cancelable: true,
    });
  };
}

export async function shareMedFlytChallengeFacebook(referralCode: string): Promise<void> {
  if (!(await cordovaPluginAvailable(CordovaPlugin.SocialSharing))) {
    return;
  }

  (window as any).plugins.socialsharing.shareViaFacebook(
    referralInviteLink(referralCode),
    undefined,
    undefined,
    undefined,
    socialShareError("Facebook")
  );
}

export async function shareMedFlytChallengeInstagram(referralCode: string): Promise<void> {
  if (!(await cordovaPluginAvailable(CordovaPlugin.SocialSharing))) {
    return;
  }

  (window as any).plugins.socialsharing.shareViaInstagram(
    referralInviteLink(referralCode),
    [],
    undefined,
    socialShareError("Instagram")
  );
}

export async function shareMedFlytChallengeWhatsApp(referralCode: string): Promise<void> {
  if (!(await cordovaPluginAvailable(CordovaPlugin.SocialSharing))) {
    return;
  }

  (window as any).plugins.socialsharing.shareViaWhatsApp(
    referralMessage(referralCode),
    undefined,
    undefined,
    undefined,
    socialShareError("WhatsApp")
  );
}

export async function shareMedFlytChallengeTwitter(referralCode: string): Promise<void> {
  if (!(await cordovaPluginAvailable(CordovaPlugin.SocialSharing))) {
    return;
  }

  (window as any).plugins.socialsharing.shareViaTwitter(
    referralMessage(referralCode),
    undefined,
    undefined,
    undefined,
    socialShareError("Twitter")
  );
}
